export default "__VITE_ASSET__B4LX9G7z__"